(() => {
  const boot = () => {
    const featuredContainer = document.querySelector(".article-featured-products[data-article-shuffle='1']");
    const gridContainer = document.querySelector(".article-product-grid[data-grid-shuffle='1']");

    if (!featuredContainer || !gridContainer) return;

    const featuredPool = featuredContainer.querySelector("[data-role='featured-pool']");
    const featuredUL = featuredContainer.querySelector("[data-role='featured']");

    const gridPool = gridContainer.querySelector("[data-role='grid-pool']");
    const gridUL = gridContainer.querySelector("[data-role='grid']");

    if (!featuredPool || !featuredUL || !gridPool || !gridUL) return;

    const featuredItems = Array.from(featuredPool.querySelectorAll("li.grid__item"));
    const gridItems = Array.from(gridPool.querySelectorAll("li.grid__item"));

    if (featuredItems.length < 3 || gridItems.length < 4) return;

    // Shuffle featured pool
    for (let i = featuredItems.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [featuredItems[i], featuredItems[j]] = [featuredItems[j], featuredItems[i]];
    }

    // Shuffle grid pool
    for (let i = gridItems.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [gridItems[i], gridItems[j]] = [gridItems[j], gridItems[i]];
    }

    const featuredPick = featuredItems.slice(0, 3);
    const gridPick = gridItems.slice(0, 4);

    featuredUL.innerHTML = "";
    gridUL.innerHTML = "";

    featuredPick.forEach((li) => featuredUL.appendChild(li.cloneNode(true)));
    gridPick.forEach((li) => gridUL.appendChild(li.cloneNode(true)));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();